<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { UserInfoType } from '@/types/user'
import { socketEmitAsync } from '@/utils/web-socket'
import { Edit, SortUp } from '@element-plus/icons-vue'

const userStore = useUserStore()

async function handleChangeRoutine(id: number) {
  const userAttr = await socketEmitAsync<UserInfoType['userAttr']>({ type: 'useEquipRoutine', data: { id } })
  userStore.handleChangeEquipRoutine(userAttr, id)
}
async function handleNameRoutine(id: number) {
  const routine = userStore.equippedRoutineList.find((item) => item.id === id)
  if (!routine) return
  ElMessageBox.prompt('请输入装备套路名称', '修改装备套路名称', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputPattern: /^[\u4e00-\u9fa5a-zA-Z0-9]{1,8}$/,
    inputValue: routine.name,
    inputErrorMessage: '套路命名在1~8字，且只允许中英文及数字',
    confirmButtonClass: 'is-plain',
    async beforeClose(action, instance, done) {
      if (action !== 'confirm') return done()
      try {
        instance.confirmButtonLoading = true
        instance.confirmButtonText = '加载中...'
        const value = instance.inputValue
        await socketEmitAsync({ type: 'nameEquipRoutine', data: { id, name: value } })
        routine.name = value
        done()
      } finally {
        instance.confirmButtonLoading = false
        instance.confirmButtonText = '确定'
      }
    },
  })
}
async function sortRoutine(id: number) {
  const idList = userStore.equippedRoutineList.map((item) => item.id)
  // 将对应id上移
  const index = idList.indexOf(id)
  if (index === 0) return ElMessage.warning('套路已在最前')
  if (index > 0) {
    idList.splice(index, 1)
    idList.splice(index - 1, 0, id)
  }
  await socketEmitAsync({ type: 'sortEquipRoutine', data: { idList } })
  userStore.equippedRoutineList.sort((a, b) => idList.indexOf(a.id) - idList.indexOf(b.id))
  ElMessage.success('排序成功')
}
</script>

<template>
  <el-select size="small" v-model="userStore.equippedRoutineId" style="margin-top: 10px" @change="handleChangeRoutine">
    <el-option v-for="item in userStore.equippedRoutineList" :key="item.id" :label="item.name" :value="item.id">
      <div style="display: flex; align-items: center; justify-content: space-between; font-size: 12px">
        <span>{{ item.name }}</span>
        <div style="display: flex; align-items: center">
          <el-icon size="18" style="color: var(--el-text-color-secondary)" @click.stop="handleNameRoutine(item.id)"><Edit /></el-icon>
          <el-icon size="18" style="color: var(--el-text-color-secondary)" @click.stop="sortRoutine(item.id)"><SortUp /></el-icon>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<style lang="scss"></style>
